import { Alert, Button, Paper, Stack } from '@mui/material';

import { Piece, PieceAnnotation, PieceType } from '@apiContract';
import Footer from '@components/DrawerContent/Footer';
import Title from '@components/DrawerContent/Title';

import Mail from './Mail';
import Package from './Package';
import { useAdditionalInfo } from './hook';
import { sxMain, sxP20, sxPaper } from './styles';

export type AdditionalInfoProps = {
  annotations: PieceAnnotation[];
  onClose: () => void;
  onCreate?: (pieceAnnotations?: PieceAnnotation[]) => void;
  piece?: Piece | null;
};

const AdditionalInfo = ({ piece, annotations = [], onClose, onCreate }: AdditionalInfoProps) => {
  const {
    showDetectedAlert,
    refreshMailClass,
    pieceType,
    annotationsState,
    onChangeValue,
    isLoading,
    saveAnnotations,
  } = useAdditionalInfo({ annotations, piece, onCreate, onClose });

  return (
    <Paper elevation={3} sx={sxPaper}>
      <Title title="Additional Info" onClose={onClose} />
      <Stack sx={sxMain} spacing={3}>
        {showDetectedAlert && (
          <Alert
            severity="info"
            action={
              <Button color="info" size="small" variant="contained" onClick={refreshMailClass}>
                Refresh
              </Button>
            }
          >
            Additional info identified automatically
          </Alert>
        )}

        {pieceType === PieceType.Mail ? (
          <Mail annotations={annotationsState} onChange={onChangeValue} />
        ) : (
          <Package onChange={onChangeValue} annotations={annotationsState} />
        )}
      </Stack>
      <Footer title="Save Changes" sx={sxP20} isLoading={isLoading} handleSubmit={saveAnnotations} />
    </Paper>
  );
};

export default AdditionalInfo;
